"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icons = _interopRequireDefault(require("./Icons"));

var createStyle = function createStyle(rotate, scale, style) {
  var transform = [rotate === 0 ? '' : "rotate(".concat(rotate, "deg)"), scale === 1 ? '' : "scale(".concat(scale, ")")].join(' ').trim();
  return transform.length ? (0, _objectSpread2.default)({
    transform: transform
  }, style) : style;
};

var Icon = function Icon(_ref) {
  var type = _ref.type,
      rotate = _ref.rotate,
      scale = _ref.scale,
      style = _ref.style,
      className = _ref.className,
      iconColor = _ref.iconColor;
  var IconComponent = _Icons.default[type];
  return IconComponent ? _react.default.createElement(IconComponent, {
    style: createStyle(rotate, scale, style),
    className: className,
    iconColor: iconColor
  }) : null;
};

Icon.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(_Icons.default)).isRequired,
  rotate: _propTypes.default.number,
  scale: _propTypes.default.number,
  style: _propTypes.default.object,
  className: _propTypes.default.string
};
Icon.defaultProps = {
  rotate: 0,
  scale: 1,
  className: '',
  style: {}
};
var _default = Icon;
exports.default = _default;